// extracted by mini-css-extract-plugin
export default {"shadowTop":"NoGroupTable_shadowTop__qUB4q","placeHolderShimmer":"NoGroupTable_placeHolderShimmer__PYG+3"};